import i18next, { type i18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import fr from '../locales/fr.json';
import en from '../locales/en.json';

export type Locale = 'fr' | 'en';

/** Fresh instance per call so tests and the app never share language state. */
export async function initI18n(lng?: Locale): Promise<i18n> {
  const instance = i18next.createInstance();
  if (!lng) instance.use(LanguageDetector);
  await instance.use(initReactI18next).init({
    lng,
    supportedLngs: ['fr', 'en'],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'fr',
    resources: { fr: { translation: fr }, en: { translation: en } },
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  });
  return instance;
}

/** Keeps `<html lang>` on the current language, including later switches (Settings, home toggle); returns the unsubscribe. */
export function followDocumentLang(instance: i18n): () => void {
  const apply = (lng: string) => {
    document.documentElement.lang = lng.startsWith('fr') ? 'fr' : 'en';
  };
  apply(instance.language);
  instance.on('languageChanged', apply);
  return () => instance.off('languageChanged', apply);
}
